import React from "react";

import Button from "@material-ui/core/Button";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useRacehorse360Api } from "hooks/api";
import Loader from "components/Loader";
import { checkExamRequirementCodeType } from "../helper";

import useStyles from "./styles";

interface Props {
  examRequirement: racehorse360.IHorseExamRequirement;
  onExamRequirementUpdate: (
    id: string,
    patch: racehorse360.IHorseExamRequirement
  ) => void;
}

const ExamRequirementStatus = ({
  examRequirement,
  onExamRequirementUpdate
}: Props) => {
  const classes = useStyles();

  const { useConfirmExamRequirementReadiness } = useRacehorse360Api();

  const { mutateAsync: changeExamStatus, isPending: isLoading } =
    useConfirmExamRequirementReadiness();

  const { isTse1Type, isHisaType } = checkExamRequirementCodeType(
    examRequirement.type.code
  );
  const isReadyForExamStatus =
    examRequirement.status ===
    racehorse360.HorseExamRequirementStatus
      .HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM;
  let buttonContent: string;

  if (isTse1Type) {
    buttonContent = "TSE-1 Form Completed";
  } else if (isHisaType) {
    buttonContent = "HISA Form Completed";
  } else {
    buttonContent = "Ready for Exam";
  }

  const handleStatusChange = async () => {
    try {
      const updatedExamRequirement = await changeExamStatus({
        id: examRequirement.id,
        getOptions: {
          select: ["id", "status"]
        }
      });

      if (!updatedExamRequirement) return;

      onExamRequirementUpdate(examRequirement.id, updatedExamRequirement);
    } catch (error) {
      console.error(error);
    }
  };

  const renderContent = () => {
    if (isLoading) return <Loader size={20} />;

    if (isReadyForExamStatus) {
      const sentRequestText =
        isTse1Type || isHisaType
          ? "Notice Sent to Vet..."
          : "Request Sent to Vet...";

      return <span className={classes.sentRequestText}>{sentRequestText}</span>;
    }

    return (
      <Button
        onClick={handleStatusChange}
        className={classes.readyForExamButton}
        variant={"outlined"}
      >
        {buttonContent}
      </Button>
    );
  };

  return <div className={classes.root}>{renderContent()}</div>;
};

export default React.memo(ExamRequirementStatus);
